@use "styles/mixins/_rem.scss" as rem;
@use "styles/mixins/_fonts.scss" as fonts;

.content-wrapper {
  align-items: center;
  background-color: var(--color-background-default);
  color: var(--color-text-default);
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  min-height: 100vh;
  position: relative;

  .error-icon {
    width: rem.torem(350px);
    color: var(--color-icon-brand-primary);
  }

  .description {
    @include fonts.title4;
  }

  .content {
    text-align: center;
  }

  .nm-redirection-link {
    margin: var(--size-spacing-3xl) auto;
  }
}

.title {
  @include fonts.title1;

  margin-top: var(--size-spacing-2xl);
  margin-bottom: var(--size-spacing-l);
  overflow-wrap: anywhere;
}
